import * as React from "react";
import { Box, Stack, Heading, Text } from "@chakra-ui/react";
import NextImage from "next/image";

import { IMarginProps } from "src/types/types";
import ContactBox from "./ContactBox";

interface IProps extends IMarginProps {
  myOwn: boolean;
}

const INContainer: React.FunctionComponent<IProps> = ({
  myOwn,
  ...margins
}) => (
  <Stack
    padding={5}
    borderRadius={7}
    borderWidth="1px"
    borderColor="ud-grey-300"
    backgroundColor="ud-grey-150"
    width="100%"
    {...margins}
    data-test="offerDetail.contactIN"
  >
    <ContactBox myOwn={myOwn} />
    <Box mt={35} data-test="offerDetail.explainIN">
      <Box mb={4} data-test="offerDetail.explainIN.header">
        <Stack spacing={3}>
          <Heading
            as="h2"
            variant="h3"
            data-test="offerDetail.explainIN.header.title"
          >
            Jsme tady pro vás po celou dobu, kdy s námi bydlíte
          </Heading>
          <Stack>
            <Text
              variant="large_1"
              data-test="offerDetail.explainIN.header.text"
            >
              Oproti bydlení na přímo s majitelem nebo skrze realitní kancelář,
              se vám zaručíme o bezstarostné bydlení a máme pro vás i další
              výhody. Přidejte se k 3 000 našim podnájemníků, o které pečujeme.
            </Text>
          </Stack>
        </Stack>
      </Box>
      <Stack spacing={5}>
        <Stack
          direction="row"
          spacing={5}
          data-test="offerDetail.explainIN.support"
        >
          <Stack alignSelf="center" flex={0.5}>
            <NextImage
              src="/img/scenes/OfferDetail/support.png"
              alt=""
              width="72"
              height="72"
              data-test="offerDetail.explainIN.support.img"
            />
          </Stack>
          <Stack direction="column" flex={2}>
            <Heading
              as="h3"
              variant="h4"
              data-test="offerDetail.explainIN.support.title"
            >
              Klientská podpora 24/7
            </Heading>
            <Text
              variant="large_1"
              data-test="offerDetail.explainIN.support.text"
            >
              K dispozici je vám naše nepřetržitá klientská podpora.
            </Text>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          spacing={5}
          data-test="offerDetail.explainIN.handlers"
        >
          <Stack alignSelf="center" flex={0.5}>
            <NextImage
              src="/img/scenes/OfferDetail/mobile.png"
              alt=""
              width="72"
              height="72"
              data-test="offerDetail.explainIN.handlers.img"
            />
          </Stack>
          <Stack direction="column" flex={2}>
            <Heading
              as="h3"
              variant="h4"
              data-test="offerDetail.explainIN.handlers.title"
            >
              Správci vždy po ruce
            </Heading>
            <Text
              variant="large_1"
              data-test="offerDetail.explainIN.handlers.text"
            >
              Ať už se během bydlení setkáte s jakoukoli situací, pomůžeme vám
              ji vyřešit.
            </Text>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          spacing={5}
          data-test="offerDetail.explainIN.insurance"
        >
          <Stack alignSelf="center" flex={0.5}>
            <NextImage
              src="/img/scenes/OfferDetail/secure.png"
              alt=""
              width="72"
              height="72"
              data-test="offerDetail.explainIN.insurance.img"
            />
          </Stack>
          <Stack direction="column" flex={2}>
            <Heading
              as="h3"
              variant="h4"
              data-test="offerDetail.explainIN.insurance.title"
            >
              Spolehlivé pojištění
            </Heading>
            <Text
              variant="large_1"
              data-test="offerDetail.explainIN.insurance.text"
            >
              Automaticky pro vás sjednáme pojištění pro větší domácí pohodu.
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  </Stack>
);

export default INContainer;
